exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".light---xwBY3, .bold---3TFEO {\n  color: #5c6c7f; }\n\n.bold---3TFEO {\n  font-weight: 600; }\n", ""]);

// exports
exports.locals = {
	"light": "light---xwBY3",
	"bold": "bold---3TFEO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/class-courses/index.scss
// module id = 1140
// module chunks = 3